function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M3.459 8.83h3.543v12.35H3.46V8.83zM5.14 7.285h-.025C3.832 7.285 3 6.341 3 5.145 3 3.926 3.856 3 5.165 3c1.307 0 2.111.923 2.137 2.142 0 1.196-.83 2.143-2.162 2.143zm16.042 13.897h-4.019v-6.393c0-1.672-.628-2.813-2.01-2.813-1.058 0-1.646.77-1.92 1.513-.102.265-.086.637-.086 1.01v6.683h-3.98s.05-11.323 0-12.352h3.98v1.938c.235-.847 1.507-2.057 3.537-2.057 2.52 0 4.498 1.778 4.498 5.602v6.869z"
  }));
};

SvgLinkedIn.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgLinkedIn.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgLinkedIn;